import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {GoogleService} from './google-service';
import {Observable} from 'rxjs';
import {EntityKey} from '../entity/entity-key';

@Service()
export class MultiplierService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  runMultiplier(entityKey: EntityKey): Observable<string> {
    const url = this.urlBase + 'multiplier/run/' + entityKey.entityId + '/' + entityKey.entityRevision;
    return this.http.get(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
